"use client";

import { useTranslations } from "next-intl";
import { useRouter } from "@lib/i18n/navigation-app-router";
import Button from "../Button";

const SharedAccountsLayout = ({ className, title }) => {
  const tAccounts = useTranslations("accounts");
  const tCommon = useTranslations("common");

  const router = useRouter();

  return (
    <div className={className}>
      <div className="text-center">
        <div className="accounts-title-container">
          <Button
            title={tCommon("back")}
            variant="ghost-dark"
            leftIconName="chevron-left"
            className="accounts-back-button"
            onClick={() => router.back()}
          />
          <h1 className="h5 mb-0 px-4">{tAccounts(title)}</h1>
          <div className="p-3 m-1" />
        </div>
      </div>
    </div>
  );
};

export default SharedAccountsLayout;
